import { UserValidationRules } from '@ringo/shared'
import { mixed } from 'yup'
import { GrooveType, Profile } from '@ringo/types'
import { useState } from 'react'

export function useValidationRules() {
    const [validationRules] = useState(() => ({
        firstName: UserValidationRules.firstName(),
        lastName: UserValidationRules.lastName(),
        email: UserValidationRules.email(),
        companyName: UserValidationRules.companyName(),
        street: UserValidationRules.street(),
        houseNumber: UserValidationRules.houseNumber(),
        postalCode: UserValidationRules.postalCode(),
        city: UserValidationRules.city(),
        telephone: UserValidationRules.telephone(),
        password: UserValidationRules.password(),
        genders: UserValidationRules.genders(),
        language: UserValidationRules.language(),
        country: UserValidationRules.country(),
        ringProfile: mixed<Profile>().oneOf(Object.values(Profile) as any, { key: 'validations.invalidProfile' }),
        grooveType: mixed<GrooveType>()
            .oneOf(Object.values(GrooveType) as any)
            .nullable(),
    }))
    return validationRules
}

export const commisionNumberMaxLength = 20
export const orderNoteMaxLengthForPosition = 40
export const orderNoteMaxLengthForShoppingCart = 100
export const favoriteNameMaxLength = 40
